<template>
  <div v-if="!patientId" class="text-center">
    Go to a patient profile to use this feature.
  </div>
  <div v-else class="pr-2">
    <h2 class="text-nash-midnightBlue700">Ask about {{ memberName }}</h2>

    <div class="overflow-visible rounded-lg mb-2 relative">
      <div class="mb-4">
        <label
          for="ai-query-dropdown"
          class="block mb-2 text-nash-midnightBlue700"
        >
          Select a question from the dropdown to learn more about this patient's
          profile. Once a response loads, use the citations to verify the
          information provided in the summary.
        </label>
        <TDropdown
          id="ai-query-dropdown"
          v-model="selectedPrompt"
          :options="promptsToOptions"
          option-label="label"
          option-value="value"
          :disabled="loading"
          placeholder="Select something to learn more about..."
          @change="updateInputText"
        />
        <TTextarea
          v-if="showDevTools"
          v-model="inputText"
          label="Dev Tools: Final Query"
          name="ai-query-input"
          :disabled="loading"
          placeholder="Alter the query here..."
        />
      </div>

      <div>
        <TMPrimaryButton
          v-if="!!llmResponses"
          class="float-right"
          :disabled="!inputText || loading"
          label="Ask Again with Deep Dive"
          @click="submitDeepDive"
        />
        <TMPrimaryButton
          class="float-right"
          :disabled="!inputText || loading"
          label="Ask"
          @click="submit"
        />
      </div>

      <LlmDevTools
        v-if="showDevTools"
        v-model="devToolOptions"
        :loading="loading"
      />

      <TMSpinnerWithMessages
        v-if="loading"
        name="AAPSpinner"
        :messages="loadingMessages"
        :partial-page="true"
      />

      <div v-if="hasError" class="mt-4 align-middle">
        <div class="italic">
          Sorry, there was an error fetching a response. Please try again with a
          different query.
        </div>
      </div>

      <div v-else-if="!!llmResponses">
        <ResponseContent
          :sections="llmResponses"
          :patient-id="patientId"
          :loading="loading"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import TMPrimaryButton from '@thyme/nashville/src/components/button/TMPrimaryButton.vue'
import TTextarea from '@thyme/nashville/src/components/forms/TTextarea/TTextarea.vue'
import TMSpinnerWithMessages from '@thyme/nashville/src/components/spinner/TMSpinnerWithMessages/TMSpinnerWithMessages.vue'
import { defineComponent } from 'vue'
import TDropdown from '@/legacy/nashville/dropdown/TDropdown.vue'
import LlmDevTools from '@/tokens/llm/LlmDevTools/LlmDevTools.vue'
import setup from './controller'
import ResponseContent from './ResponseContent/ResponseContent.vue'
import { ASK_A_PROFILE_PROPS } from './types'

export default defineComponent({
  components: {
    TMPrimaryButton,
    TMSpinnerWithMessages,
    TDropdown,
    LlmDevTools,
    ResponseContent,
    TTextarea,
  },
  props: ASK_A_PROFILE_PROPS,
  setup,
})
</script>
